import { render, staticRenderFns } from "./IconBilling.vue?vue&type=template&id=4fd9781c&functional=true"
import script from "./IconBilling.vue?vue&type=script&lang=js"
export * from "./IconBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports